<template>
	<unauth-layout>
		<template slot="page-content">

			<h2 id="privacy-title">
			  Privacy Policy of onestore.io
			</h2>

			<vue-markdown class='markdown privacy' :source="privacyPolicyMD" v-once>
			</vue-markdown>

			<div id="footer-firstpage"></div>

		</template>
	</unauth-layout>
</template>

<script>
const logger = require("@/utils/logger");
import router from "../router";
import VueMarkdown from "vue-markdown";

const privacyPolicyMD = require("@/assets/markdown/privacy.md");

export default {
  props: ["error"],
  data() {
    return {
      origin: window.location.origin,
      show: true,
      html: true,
      breaks: true,
      linkify: false,
      emoji: true,
      typographer: true,
      toc: true,
      tocSource: "",
      tocAnchorLink: false,
      modalTitle: "",
      modalContent: "",
      privacyPolicyMD: privacyPolicyMD
    };
  },
  components: {
    VueMarkdown
  }
};
</script>

<style>
#privacy-title {
  text-align: center;
  margin: 2em 0;
}
.markdown {
  margin-top: 0;
}
.markdown {
  clear: both;
}
.privacy h2 {
  margin-top: 30px;
  font-size: 1.5em;
  font-weight: bold;
}
.privacy h3 {
  margin-top: 20px;
  font-size: 1.2em;
}
.privacy p {
  margin-top: 20px;
}
#footer-firstpage {
  border-color: #ccc;
  border-bottom: 1px dashed #ccc;
  margin: 40px 0 40px 0;
}
.markdown a,
#toc {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue